module.exports = __webpack_public_path__ + "img/7.3384212d.png";